import {BorderPanel} from '@unifocus/react-components';
import React, {ReactElement, ReactNode} from 'react';

const unifocusLogoWhite = () => {
   return (
      <div className={'unifocus-logo unifocus-logo-white'}></div>
   );
};

const unifocusLogoMulti = () => {
   return (
      <div className={'unifocus-logo unifocus-logo-multi'}></div>
   );
};

const unifocusLogoFullColor = () => {
   return (
      <div className={'unifocus-logo unifocus-logo-fullcolor'}></div>
   );
};

const logoPanel = () => {
   return (
      <div className="unifocus-logo-panel">
         {unifocusLogoFullColor()}
      </div>
   );
};

export interface LogoContentPanelProps {
   footer?: ReactElement;

   /**
    * The children.
    */
   children?: ReactNode;
}

export const LogoContentPanel = (props: LogoContentPanelProps) => {
   return (
      <BorderPanel
         className={'outer-content-panel'}
      >
         <BorderPanel
            className="content-panel content-panel-size"
            top={logoPanel()}
            bottom={props.footer}
            // horizontalFill={false}
         >
            {props.children}
         </BorderPanel>
      </BorderPanel>
   );
};
